import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

import {
  Row,
  Span,
} from 'components'

import { IBarReportResponse } from 'services/GST/Dashboard'
import { SPACING, COLORS } from 'utils'

import { useDashboard } from '../../../../context'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

interface ILinearViewProps {
  data: IBarReportResponse[]
}

const LinearView: React.FC<ILinearViewProps> = ({
  data,
}) => {
  const {
    contentReportType
  } = useDashboard()

  return (
    <>
      {
        contentReportType === 'itens' && (
          <Row
            justifyContent="center"
            marginBottom={SPACING.spacing20}
          >
            <Span
              text="Quantidade x Item Segurança"
              fontSize="1.5rem"
            />
          </Row>
        )
      }
      <Bar
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
        data={{
          labels: data?.map(item => item.nomeItemSeguranca),
          datasets: [
            {
              data: data?.map(item => item.quantidadeItens),
              backgroundColor: COLORS.blueFonts,
            }
          ]
        }}
      />
    </>
  )
}

export default LinearView
